@use '../../scss/utility';

:host {
  --color: var(--wb-grey-20);
  --outline-color: var(--wb-blue-45);

  display: inline;
}

a {
  background-color: transparent;
  cursor: pointer;
  text-decoration: none;
  outline-color: var(--outline-color);
  color: var(--color);
  -webkit-tap-highlight-color: transparent;
}

a:focus {
  outline-width: utility.wb-pixel-to-rem(1px);
  outline-style: solid;
  outline-offset: utility.wb-pixel-to-rem(5px);
}

:host([variant='inline']) {
  --color: var(--wb-blue-45);
}

:host([variant='inline']) a {
  border-block-end: utility.wb-pixel-to-rem(1px) solid currentColor;
}

:host([variant='inline']:hover),
:host([variant='inline']:focus) {
  --color: var(--wb-blue-35);
}

:host([theme='dark'][variant='inline']) {
  --color: var(--wb-blue-55);
}

:host([theme='dark'][variant='inline']:hover),
:host([theme='dark'][variant='inline']:focus) {
  --color: var(--wb-blue-65);
}

:host([variant='standalone']) a {
  @include utility.wb-text(
    'l',
    (
      strong: true,
      responsive: false,
    )
  );
  background-image: linear-gradient(to top, var(--wb-blue-45) 2px, transparent 2px), linear-gradient(to top, var(--wb-grey-70) 1px, transparent 1px);
}

:host([variant='standalone'][theme='dark']) {
  --color: var(--wb-white);
}

:host([variant='standalone'][theme='dark']) a {
  background-image: linear-gradient(to top, var(--wb-blue-50) 2px, transparent 2px), linear-gradient(to top, var(--wb-grey-70) 1px, transparent 1px);
}

:host([variant='small']) a {
  @include utility.wb-text('m');
}

:host([variant='tiny']) a {
  @include utility.wb-text(
    's',
    (
      strong: true,
    )
  );
}

:host([variant='small']) a,
:host([variant='tiny']) a {
  background-image: linear-gradient(to top, var(--wb-black) 1px, transparent 1px);
}

:host([variant='small']:hover),
:host([variant='small']:focus-within),
:host([variant='tiny']:hover),
:host([variant='tiny']:focus-within) {
  --color: var(--wb-black);
}

:host([variant='small'][theme='dark']),
:host([variant='tiny'][theme='dark']) {
  --color: var(--wb-grey-70);
}

:host([variant='small'][theme='dark']) a,
:host([variant='tiny'][theme='dark']) a {
  background-image: linear-gradient(to top, var(--wb-white) 1px, transparent 1px);
}

:host([theme='dark'][variant='small']:hover),
:host([theme='dark'][variant='small']:focus-within),
:host([theme='dark'][variant='tiny']:hover),
:host([theme='dark'][variant='tiny']:focus-within) {
  --color: var(--wb-white);
}

:host([variant='standalone']) a,
:host([variant='small']) a,
:host([variant='tiny']) a {
  background-repeat: no-repeat, no-repeat;
  background-position-x: left;
  background-size: 0% 100%, 100% 100%;
  padding-block-end: utility.wb-pixel-to-rem(2px);
  transition: background-size 0.42s cubic-bezier(0.165, 0.84, 0.44, 1);
  background-origin: right;

  @media (prefers-reduced-motion) {
    transition: background-size 0s;
  }
}

:host([is-rtl]) a {
  background-position-x: right;
}

:host([variant='standalone']:hover) a,
:host([variant='standalone']:focus-within) a,
:host([variant='small']:hover) a,
:host([variant='small']:focus-within) a,
:host([variant='tiny']:hover) a,
:host([variant='tiny']:focus-within) a {
  background-size: 100% 100%, 100% 100%;
}

::slotted(.wb-icon) {
  --size: #{utility.wb-pixel-to-rem(12px)};
  overflow: hidden;
  margin-inline-end: utility.wb-pixel-to-rem(8px);
}
